/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
'use strict';

/**
 * Filter module for converting stuff into human readable format.
 */
angular
  .module('filters.humanize', [])
  /**
   * Filter used to convert from bytes to a human readable size.
   *
   * @param {Number} bytes - The bytes value to be converted.
   *
   * @returns {String} A String representing the number.
   */
  .filter('fromBytes', function () {
    return function (bytes) {
      if (bytes <= 0) {
        return 0;
      }
      var s = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
      var e = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, Math.floor(e))).toFixed(0) + s[e];
    };
  })
  /**
   * Filter used to convert num to shortened form if equal or over 1000.
   *
   * @param {Number} num - The value to be converted.
   *
   * @returns {String} A String representing the number.
   */
  .filter('shortNum', function () {
    return function (num) {
      if (num <= 0) {
        return 0;
      }
      // Billion
      if (num >= 1000000000) {
        num = num / 1000000000;
        num = Math.floor(num * 100) / 100;
        return num + 'B';
      } else if (num >= 1000000) {
        // Million
        num = num / 1000000;
        num = Math.floor(num * 10) / 10;
        return num + 'M';
      } else if (num >= 1000) {
        // Thousand
        num = num / 1000;
        num = Math.floor(num * 10) / 10;
        return num + 'K';
      } else {
        // Number below 1000
        return num;
      }
    };
  });
